import { safe } from "./utils/safe";

/** RFC4122 v4 id: crypto.randomUUID (secure ctx) → getRandomValues (http-контекст). */
export function uuid(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c?.randomUUID) return c.randomUUID();
  if (c?.getRandomValues) {
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6]! & 0x0f) | 0x40;
    b[8] = (b[8]! & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, "0"));
    return `${h.slice(0, 4).join("")}-${h.slice(4, 6).join("")}-${h.slice(6, 8).join("")}-${h.slice(8, 10).join("")}-${h.slice(10, 16).join("")}`;
  }
  // crypto недоступен (в реальном браузере не встречается) — не-crypto запасной id, лишь бы не бросить.
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 14)}`;
}

function readCookie(name: string): string | null {
  return safe(() => {
    const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]!) : null;
  }, null);
}

function writeCookie(name: string, value: string): void {
  safe(() => {
    // 2-year first-party cookie, lax so it survives top-level navigations.
    const maxAge = 60 * 60 * 24 * 730;
    const secure = location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  }, undefined);
}

/**
 * Persistent device id. Cookie is the source of truth; localStorage is a mirror so the
 * id survives cookie clearing where storage is kept (and vice versa).
 */
export function getOrCreateDeviceId(cookieName: string): string {
  const fromCookie = readCookie(cookieName);
  const fromStorage = safe(() => localStorage.getItem(cookieName), null);
  const id = fromCookie || fromStorage || uuid();

  if (id !== fromCookie) writeCookie(cookieName, id);
  if (id !== fromStorage) safe(() => localStorage.setItem(cookieName, id), undefined);
  return id;
}

/** First matching URL param value, else null. */
export function getTrackerClickId(params: string[]): string | null {
  return safe(() => {
    const sp = new URLSearchParams(location.search);
    for (const key of params) {
      const v = sp.get(key);
      if (v) return v;
    }
    return null;
  }, null);
}
